<template>
  <Modal v-if="cancel.id" title="予約キャンセル" hideCloseButton :loading="cancel.busy" @close="hideCancelModal">
    <div class="content">
      <p v-if="isBlock">ブロックをキャンセルしてよろしいですか？</p>
      <template v-else>
        <template
          v-if="isResrakuReserve.isResraku || isConfirmedResrakuReserve.confirmed || isConfirmedResrakuReserve.isOver"
        >
          <p
            v-if="(isResrakuReserve.isResraku || isConfirmedResrakuReserve.confirmed) && !isResrakuAlignment"
            class="note"
          >
            レスラクとの連携が<br v-if="!isSP" />「未連携」または
            <br v-if="isSP" />「一時停止」「停止」になっています。<br />
            キャンセルされる場合は<br v-if="isSP" />媒体管理画面をご確認ください。
          </p>
          <p v-else class="note">媒体の予約変更可能期限を経過しています。<br />媒体管理画面をご確認ください。</p>
          <p class="note">台帳上の予約変更は可能ですが、<br />レスラク及び媒体へは連携されません。</p>
        </template>
        <template v-else-if="isGnavi && isAfterVisitConfirmation">
          <p class="note">
            予約変更可能期限を経過しています。
            <br />
            台帳上は予約キャンセルされますが、
            <br />
            ぐるなびネット予約の予約管理へは連携されません。
          </p>
        </template>
        <p class="note">予約をキャンセルしてよろしいですか？<br />※事前キャンセルとして登録されます。</p>
        <CheckBox v-if="!isResraku" v-model="unauthorized">
          無断キャンセルとして登録する
        </CheckBox>
      </template>
    </div>
    <template #footer-center>
      <Button @click="hideCancelModal">戻る</Button>

      <StaffSelectPopover placement="top-end" @update:open="isShowStaffList = $event" @select="selectStaff">
        <Button danger :disabled="isShowStaffList" @click="onClickConfirm">確定</Button>
      </StaffSelectPopover>
    </template>
  </Modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { models } from '@/utils/vue'
import { isResrakuAlignment } from '@/utils/store'
import { isResrakuReserve, isConfirmedResrakuReserve, isAfterVisitConfirmation } from '@/utils/reserve'
import Button from '@/components/atoms/Button'
import CheckBox from '@/components/atoms/CheckBox'
import Modal from '@/components/molecules/Modal'
import StaffSelectPopover from '@/components/organisms/StaffSelectPopover'
import { isBlock } from '@/resources/reservation/typeMap'
import { isGnavi } from '@/resources/reservation/syncTypeMap'

export default {
  name: 'ReserveCancelModal',
  components: {
    Button,
    CheckBox,
    Modal,
    StaffSelectPopover,
  },
  data() {
    return {
      isShowStaffList: false,
    }
  },
  computed: {
    ...mapState({
      isSP: state => state.app.isSP,
      cancel: state => state.reserves.cancel,
      reserves: state => state.reserves.edit,
      reserveDetail: state => state.reserves.detail,
      currentStore: state => state.stores.current.store,
    }),
    ...mapGetters({
      allStaffs: 'staffs/all',
    }),
    ...models(
      ['unauthorized'],
      ({ cancel }, key) => cancel.extra[key],
      ({ $store }, key, value) => $store.commit('reserves/cancel/update', { [key]: value }),
    ),
    isBlock() {
      return isBlock(this.reserves.detail.reservation.type)
    },
    isResrakuReserve() {
      return isResrakuReserve(this.reserves.detail.reservation)
    },
    isResraku() {
      return (
        this.isResrakuReserve.inquiry ||
        this.isResrakuReserve.request ||
        this.isResrakuReserve.hotpepper ||
        this.isResrakuReserve.retty
      )
    },
    isConfirmedResrakuReserve() {
      return isConfirmedResrakuReserve(this.reserves.detail.reservation)
    },
    isResrakuAlignment() {
      return isResrakuAlignment(this.currentStore)
    },
    isGnavi() {
      return isGnavi(this.reserveDetail.reservation.syncType)
    },
    isAfterVisitConfirmation() {
      return isAfterVisitConfirmation(this.reserveDetail.reservation.reserveDatetime)
    },
  },
  mounted() {
    this.$store.dispatch('staffs/get')
  },
  beforeDestroy() {
    this.hideCancelModal()
  },
  methods: {
    onClickConfirm() {
      if (this.allStaffs.length > 1) {
        this.isShowStaffList = true
      } else {
        this.execCancel(this.allStaffs[0])
      }
    },
    hideCancelModal() {
      this.$store.commit('reserves/cancel/hide')
    },
    async execCancel(staff) {
      const staffId = staff.id
      const reserveId = this.cancel.id
      if (await this.$store.dispatch('reserves/cancel/cancelReservation', { staffId })) {
        this.hideCancelModal()
        this.$emit('change', reserveId)
      }
    },
    async selectStaff(staff) {
      this.isShowStaffList = false
      await this.execCancel(staff)
      this.hideCancelModal()
    },
  },
}
</script>

<style lang="postcss" scoped>
.content {
  display: grid;
  grid-gap: 24px;
  justify-content: center;

  .note {
    text-align: center;
  }

  .check-box {
    justify-content: center;
    width: auto;
  }

  .responsive & {
    @media screen and (--sp-modal) {
      line-height: 1.4;
      .check-box {
        margin-left: 10px;
      }
    }
  }
}

.responsive {
  @media screen and (--sp-modal) {
    .v-popover {
      width: auto;
    }
  }
}
</style>
